module.exports = __webpack_public_path__ + "static/media/homeSection2pic.6c53a4af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/homeSection2pic.jpg
// module id = 106
// module chunks = 0